<template>
  <div class="index-container">
    <keep-alive>
      <router-view ref="container" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view ref="container" v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'container',
}
</script>

<style>
.index-container {
  height: 100%;
}
.el-menu {
  border: 0;
  width: 200px;
}
</style>
